import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UiState } from "./uiTypes";

const initialState: UiState = {
  loading: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    clearLoading: (state) => {
      state.loading = false;
    },
    clearUi: (state) => {
      state.loading = false;
    },
  },
});

export const { setLoading, clearLoading, clearUi } = uiSlice.actions;

export default uiSlice.reducer;
